import type { ApiResponse, UserWithProfile, UpdateUserPayload, ChangePasswordRequest } from '@klaro7/shared-types';

import api, { extractErrorMessage } from '@/lib/api';

export interface UpdateProfilePayload {
  firstName?: string;
  lastName?: string;
  nickname?: string;
  phone?: string;
  dateOfBirth?: string;
  bio?: string;
}

export async function updateProfile(data: UpdateProfilePayload): Promise<UserWithProfile> {
  try {
    const payload: UpdateUserPayload = {
      profile: {
        firstName: data.firstName,
        lastName: data.lastName,
        nickname: data.nickname,
        phone: data.phone,
        dateOfBirth: data.dateOfBirth ? new Date(data.dateOfBirth) : undefined,
        bio: data.bio,
      },
    };
    const response = await api.put<ApiResponse<UserWithProfile>>('/auth/me', payload);
    return response.data.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}

export async function uploadAvatar(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('avatar', file);
  try {
    const response = await api.post<ApiResponse<{ url: string }>>('/auth/me/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data.url;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}

export async function changePassword(data: ChangePasswordRequest): Promise<void> {
  try {
    await api.put('/auth/me/password', data);
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
}
